import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PasswordResetRequest {
  @jsonMember readonly password!: string;

  constructor(password: string) {
    this.password = password;
  }
}
